// Shared file-type helpers so the CMS and the topic view categorise and icon
// attachments consistently. Soft outline icons to match the rest of the UI.
import {
  HiOutlineDocumentText,
  HiOutlineDocument,
  HiOutlineTableCells,
  HiOutlinePresentationChartBar,
  HiOutlineArchiveBox,
  HiOutlinePhoto,
  HiOutlineFilm,
  HiOutlinePaperClip,
} from "react-icons/hi2";

export const IMAGE_EXT = ["png", "jpg", "jpeg", "webp", "gif", "bmp", "svg"];
export const VIDEO_EXT = ["mp4", "webm", "ogg", "mov", "m4v"];

const ext = (name = "") => (name.split(".").pop() || "").toLowerCase();

// "image" and "video" render inline; everything else is a downloadable file.
export function fileKind(filename) {
  const e = ext(filename);
  if (IMAGE_EXT.includes(e)) return "image";
  if (VIDEO_EXT.includes(e)) return "video";
  return "file";
}

export function fileIcon(filename) {
  const e = ext(filename);
  if (e === "pdf") return HiOutlineDocumentText;
  if (["doc", "docx", "rtf", "txt", "odt", "pages"].includes(e)) return HiOutlineDocument;
  if (["xls", "xlsx", "csv", "ods", "numbers"].includes(e)) return HiOutlineTableCells;
  if (["ppt", "pptx", "odp", "key"].includes(e)) return HiOutlinePresentationChartBar;
  if (["zip", "rar", "7z", "tar", "gz"].includes(e)) return HiOutlineArchiveBox;
  if (IMAGE_EXT.includes(e)) return HiOutlinePhoto;
  if (VIDEO_EXT.includes(e)) return HiOutlineFilm;
  return HiOutlinePaperClip;
}

export function fileTypeLabel(filename) {
  return (ext(filename) || "FILE").toUpperCase();
}
